export const INCOME = {
  nickname: 'PRODUCTS.INCOME.shortname',
  isHidden: true,
  icon:'income'
};
